import script from "./Select.vue?vue&type=script&setup=true&lang=js"
export * from "./Select.vue?vue&type=script&setup=true&lang=js"

import "./Select.vue?vue&type=style&index=0&id=3005b7b4&scoped=true&lang=css"

import exportComponent from "/home/jon/Work/ldpos-wallet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3005b7b4"]])

export default __exports__